(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  (function() {
    var nav = document.getElementById('pop-nav');
    var hamburger = document.getElementById('pop-hamburger');
    var mobileMenu = document.getElementById('pop-mobile-menu');

    if (nav) {
      window.addEventListener('scroll', function() {
        nav.classList.toggle('scrolled', window.scrollY > 20);
      }, { passive: true });
    }

    if (hamburger && mobileMenu) {
      hamburger.addEventListener('click', function() {
        var isOpen = mobileMenu.classList.toggle('open');
        hamburger.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
        mobileMenu.setAttribute('aria-hidden', isOpen ? 'false' : 'true');
      });
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pop-club-faq"] && !Shopify.designMode) return;
  try {
    
  (function() {
    document.querySelectorAll('.pop-club-faq__question').forEach(function(q) {
      q.addEventListener('click', function() {
        var item = q.closest('.pop-club-faq__item');
        item.classList.toggle('open');
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product"]) return;
  try {
    
  (function() {
    // Gallery thumbnail switching
    var thumbs = document.querySelectorAll('.pop-product__gallery-thumb');
    var mainImg = document.getElementById('gallery-main-img');
    if (thumbs.length && mainImg) {
      thumbs.forEach(function(thumb) {
        thumb.addEventListener('click', function() {
          thumbs.forEach(function(t) { t.classList.remove('active'); });
          thumb.classList.add('active');
          mainImg.src = thumb.dataset.src;
          if (thumb.dataset.alt) mainImg.alt = thumb.dataset.alt;
        });
      });
    }

    // Quantity stepper
    var qtyInput = document.getElementById('pop-qty-input');
    var qtyMinus = document.getElementById('pop-qty-minus');
    var qtyPlus  = document.getElementById('pop-qty-plus');
    if (qtyInput && qtyMinus && qtyPlus) {
      qtyMinus.addEventListener('click', function() {
        var val = parseInt(qtyInput.value) || 1;
        if (val > 1) qtyInput.value = val - 1;
      });
      qtyPlus.addEventListener('click', function() {
        qtyInput.value = (parseInt(qtyInput.value) || 1) + 1;
      });
    }

    // Variant option switching
    var variantIdInput = document.getElementById('pop-variant-id');
    var priceEl = document.getElementById('pop-product-price');
    var variantOptions = document.querySelectorAll('.pop-product__variant-option');
    if (variantOptions.length && variantIdInput) {
      variantOptions.forEach(function(option) {
        option.addEventListener('click', function() {
          variantOptions.forEach(function(o) { o.classList.remove('selected'); });
          option.classList.add('selected');
          variantIdInput.value = option.dataset.variantId;
          if (priceEl && option.dataset.price) priceEl.textContent = option.dataset.price;
        });
        option.addEventListener('keydown', function(e) {
          if (e.key === 'Enter' || e.key === ' ') option.click();
        });
      });
    }
  })();

  } catch(e) { console.error(e); }
})();
})();
